import React, { useState } from 'react';
import { QuestionCopyButton } from '../../DTQuestionOrInstruction.styles';

const CopyToChatButton = ({ onClick }) => {
  const [showCopiedText, setShowCopiedText] = useState(false);

  const handleClick = () => {
    setShowCopiedText(true);
    onClick();
    setTimeout(() => {
      setShowCopiedText(false);
    }, 3000);
  };

  const copyText = showCopiedText ? 'Copied' : 'Copy to chat';

  return (
    <QuestionCopyButton onClick={handleClick}>
      <img alt="copy-to-chat" src="/images/copy.svg" />
      {copyText}
    </QuestionCopyButton>
  );
};

export default CopyToChatButton;
